import React from "react";
import "./mujeres.css";
import { getStaticUrl } from "../../../../utils/getStaticUrl";

function ProgBanner() {
  return (
    <div>
      <img
        src={getStaticUrl("banner/bannermaestras.png")}
        alt="Program Banner"
        loading="eager"
      />
      <div className="mujeres_text">
        <p>
          RedMaestra te ofrece la oportunidad de aprender un oficio y ampliar
          tus posibilidades laborales
        </p>
        <a href="https://redmaestra.azurewebsites.net/api/formularios/agregar_comunidades/">
          <span>Soy mujer, quiero inscribirme</span>
        </a>
      </div>
    </div>
  );
}

export default ProgBanner;
